import React from 'react';
import Mp4Video from 'components/InPageFeatures/Mp4Video';
import { WebsiteImage } from 'components/TitleDescription';
import RichText from 'components/RichText';
import InPageFeaturesCtaButton from './InPageFeaturesCtaButton';
import WistiaVideo from 'components/WistiaVideo';

import { FeaturedContentInnerContainer, RichTextContainer } from './styles';

const InPageFeaturesV3FeaturedContent = ({ item }) => {
  const link = item.link;
  const itemType =
    item?.featuredImage?.image?.file?.contentType === 'video/mp4'
      ? 'mp4'
      : item?.featuredVideo
      ? 'wistiaVideo'
      : 'image';

  const featuredContent =
    itemType === 'image' ? (
      <FeaturedContentInnerContainer style={{ maxHeight: '100%', display: 'contents' }}>
        <WebsiteImage
          src={item?.featuredImage?.image}
          alt={item?.featuredImage?.alt}
          imgStyles={{ objectFit: 'contain' }}
          style={{ maxHeight: '100%' }}
        />
      </FeaturedContentInnerContainer>
    ) : itemType === 'mp4' ? (
      <FeaturedContentInnerContainer>
        <Mp4Video src={item?.featuredImage?.image?.file?.url} />
      </FeaturedContentInnerContainer>
    ) : (
      <WistiaVideo url={item?.featuredVideo?.sharableLink} />
    );

  return (
    <>
      {featuredContent}
      <RichTextContainer>
        <RichText content={item?.description?.json} />
        {link && <InPageFeaturesCtaButton to={link} />}
      </RichTextContainer>
    </>
  );
};

export default InPageFeaturesV3FeaturedContent;
